var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MKBTable',{attrs:{"show-result":"","elevation":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }